import { availableSections, defaultSection, Section } from './sections'

import { ExternalServices } from './ExternalServices'
import HistoryFilterProvider from './HistoryLink/filters/HistoryFilterProvider'

type Props = {
  type?: string
  orgId: number
}

const ContentView = ({ type, orgId }: Props) => {
  const section = availableSections.includes(type as Section)
    ? (type as Section)
    : defaultSection

  if (!orgId) {
    return null
  }

  return (
    <HistoryFilterProvider orgId={orgId} section={section}>
      {(filterParams) => (
        // <OrgSettingsHistoryProvider {...filterParams}>
        //   {section === sections.VENDING_INTEGRATION_EXTERNAL_SERVICES_SETTINGS && orgId ? (
        <ExternalServices />
        //   ) : null}
        // </OrgSettingsHistoryProvider>
      )}
    </HistoryFilterProvider>
  )
}

export default ContentView
